const LOGO_URL = '/logo.png';

export function Logo({ size = 'md', showText = true }) {
  const sizes = {
    sm: { img: 'w-8 h-8', text: 'text-base', sub: 'text-[8px]' },
    md: { img: 'w-10 h-10', text: 'text-xl', sub: 'text-[9px]' },
    lg: { img: 'w-14 h-14', text: 'text-3xl', sub: 'text-[10px]' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-2.5">
      <img
        src={LOGO_URL}
        alt="Hire Hub Logo"
        className={`${s.img} object-contain shrink-0`}
      />
      {showText && (
        <div>
          <h1 className={`${s.text} font-heading font-bold text-foreground tracking-tight leading-tight`}>HireHub</h1>
          <p className={`${s.sub} text-muted-foreground uppercase tracking-[0.15em] font-body leading-tight`}>It Solutions Pvt. Ltd.</p>
        </div>
      )}
    </div>
  );
}
